class ToggleSearchInput {
  constructor() {
    this.body = document.querySelector('body');
    this.button = document.querySelector('.js--search-toggle');
    this.input = document.querySelector('.js--search-input');

    this.activeClass = 'search-input-active';
    this.activeBodyClass = 'search-active';
    this.searchIsOpen = false;
    this.bindEvents();
  }

  bindEvents() {
    this.button.addEventListener('click', () => this.open(), true);

    // close search input when clicking outside of it or the button
    this.body.addEventListener('mouseup', e => {
      if (this.searchIsOpen && (e.target !== this.input || this.button.contains(e.target))) {
        setTimeout(() => this.close(), 50);
      }
    });
  }

  open() {
    this.input.setAttribute('aria-expanded', true);
    this.input.setAttribute('aria-hidden', false);
    this.input.setAttribute('tabindex', '0');
    this.input.classList.add(this.activeClass);
    this.body.classList.add(this.activeBodyClass);
    this.searchIsOpen = true;
    this.input.focus();
  }

  close() {
    this.input.setAttribute('aria-expanded', false);
    this.input.setAttribute('aria-hidden', true);
    this.input.setAttribute('tabindex', '-1');
    this.input.classList.remove(this.activeClass);
    this.body.classList.remove(this.activeBodyClass);
    this.searchIsOpen = false;
    this.button.focus();
  }
}

export default ToggleSearchInput;
